import { AxiosInstance } from "axios"

export interface DeleteAgencyUserResponse {
  time: string
  apiStatus: string
  data: {
    taPriceConfigId: number
    message: string
    userId: number
  }
}

export function deleteAgencyUserApi(
  userId: number,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "delete",
    url: `/agent/agency/user/${userId}`,
  }) as Promise<{ data: DeleteAgencyUserResponse }>
}
